const ZENDESK_KEY = '199c940a-0e3e-4079-a474-c775b52fcb79'

let zendeskPromise = null

function loadZendesk (locale = 'en') {
  // 已存在
  if (window.zE) {
    return Promise.resolve(window.zE)
  }

  // loading中
  if (zendeskPromise) {
    return zendeskPromise
  }

  zendeskPromise = new Promise((resolve, reject) => {
    window.zESettings = {
      cookies: false,
      messaging: {
        locale
      }
    }

    const existScript = document.getElementById('ze-snippet')

    // 避免重复插入
    if (existScript) {
      resolve(window.zE)
      return
    }

    const script = document.createElement('script')

    script.id = 'ze-snippet'
    script.async = true
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_KEY}`

    script.onload = () => {
      if (window.zE) {
        resolve(window.zE)
      } else {
        reject(new Error('Zendesk load failed'))
      }
    }

    script.onerror = () => {
      reject(new Error('Zendesk script load error'))
    }

    document.body.appendChild(script)
  })

  return zendeskPromise
}

export default ({ app }, inject) => {
  const init = async (locale = 'en') => {
    if (process.server) { return }

    try {
      const zE = await loadZendesk(locale)

      zE(() => {
        console.log('Zendesk Messaging Ready')

        // 默认关闭
        zE('messenger', 'close')
      })
    } catch (e) {
      console.error(e)
    }
  }

  const open = () => {
    if (!window.zE) { return }

    window.zE('messenger', 'open')
  }

  const close = () => {
    if (!window.zE) { return }

    window.zE('messenger', 'close')
  }

  const show = () => {
    if (!window.zE) { return }

    try {
      window.zE('messenger', 'show')
    } catch (e) {}
  }

  const hide = () => {
    if (!window.zE) { return }

    try {
      window.zE('messenger', 'hide')
    } catch (e) {}
  }

  const setLocale = (locale) => {
    if (!window.zE) { return }

    try {
      window.zE('messenger:set', 'locale', locale)
    } catch (e) {
      console.warn('Zendesk locale switch failed')
    }
  }

  inject('zendesk', {
    init,
    open,
    close,
    show,
    hide,
    setLocale
  })
}
